import { useState } from "react";


function Select(props) {
    const [showError, setShowError] = useState(false);

    function blurHandler(e) {
        const { value } = e.target;
        if (props.required) {
            if (value === '') {
                setShowError(true);
                let inputErrors = [...props.inputErrors];
                inputErrors[props.index] = 'error';
                props.setInputErrors(inputErrors);
            } else {
                setShowError(false);
                let inputErrors = [...props.inputErrors];
                inputErrors[props.index] = '';
                props.setInputErrors(inputErrors);
            }
        }
    }

    return (
        <>
            <div className="flex flex-row">
                {props.required === true && <span className="text-red-500">*</span>}
                <select
                    data-testid={props.testId || ''}
                    name={props.name}
                    value={props.value}
                    className={props.className}
                    required={props.required}
                    onChange={(e) => props.onChange(e)}
                    onBlur={(e) => blurHandler(e)}
                >
                    {!props.value && <option value={''}>Select {props.placeHolder}</option>}
                    {
                        props.options.map((op, ind) => <option key={ind} value={props.valueKey ? op[props.valueKey] : op}>{props.nameKey ? op[props.nameKey] : op}</option>)
                    }
                </select>
            </div>
            <div className="text-red-500 text-xs font-semibold px-2 ">
                {
                    (showError || (props.required && props.missingFields.includes(props.name))) && 'Required field!'
                }
                {
                    props.name === 'currency' && props.value?.length > 0 && !props.validCurrency.includes(props.value) && `Only ${props.validCurrency} is valid`
                }
            </div>
        </>
    )
}

export default Select;